import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
/**
 * @param {string} props name - Input name
 * @param {string} props id - Input id
 * @param {Array<value, label, disabled, color>} props options
 * @param {function} props onChange
 *
 * @returns {JSX Component}
 */

var SimpleSelect = /*#__PURE__*/function (_Component) {
  _inherits(SimpleSelect, _Component);

  var _super = _createSuper(SimpleSelect);

  function SimpleSelect(props) {
    var _this;

    _classCallCheck(this, SimpleSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (newProps) {
      if (newProps.selectedValue !== _this.props.selectedValue) {
        _this.setState({
          value: newProps.selectedValue
        });
      }

      _this.setState({
        disabled: newProps.disabled
      });

      _this.parseOptions();
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (option) {
      _this.setState({
        value: option.value
      }, function () {
        _this.props.onChange(_this.props.item, option);
      });
    });

    _this.state = {
      value: _this.props.selectedValue != null ? _this.props.selectedValue : null,
      disabled: _this.props.disabled != null ? _this.props.disabled : false,
      options: []
    };
    return _this;
  }

  _createClass(SimpleSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.parseOptions();
    }
  }, {
    key: "parseOptions",
    value: function parseOptions() {
      var initOptions = [];

      if (this.props.status != null) {
        if (this.props.type == 'assignment') {
          initOptions = this.props.status.assignmentTaskStatus.filter(function (t) {
            return t.selectable;
          });
        } else if (this.props.type == 'planning') {
          initOptions = this.props.status.planningStatus.filter(function (t) {
            return t.selectable;
          });
        } else if (this.props.type == 'assessment') {
          initOptions = this.props.status.assessmentStatus.filter(function (t) {
            return t.selectable;
          });
        }
      }

      var options = initOptions.map(function (option) {
        if (option != undefined) {
          var color = option.color ? /*#__PURE__*/React.createElement("span", {
            className: "simple-select__color",
            style: {
              backgroundColor: option.color
            }
          }) : null;
          var obj = {
            value: option.id,
            label: /*#__PURE__*/React.createElement("span", {
              className: "simple-select__label"
            }, color, option.value)
          };
          return obj;
        }
      });
      this.setState({
        options: options
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectValue = null;

      if (this.state.options != null) {
        selectValue = this.state.options.find(function (option) {
          return option.value == _this2.state.value;
        });
      }

      return /*#__PURE__*/React.createElement(Select, {
        isDisabled: this.state.disabled,
        isSearchable: false,
        isClearable: false,
        name: this.props.name,
        menuPosition: this.props.menuPosition,
        value: selectValue,
        options: this.state.options,
        onChange: function onChange(value) {
          return _this2._onChange(value);
        },
        className: "simple-select",
        placeholder: this.props.placeholder != null ? this.props.placeholder : '',
        components: {
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      });
    }
  }]);

  return SimpleSelect;
}(Component);

function mapStateToProps(state) {
  return {
    status: state.status.status
  };
}

export default connect(mapStateToProps, {})(SimpleSelect);